import { render, staticRenderFns } from "./CategoriesAltum.vue?vue&type=template&id=d77b27da&"
import script from "./CategoriesAltum.vue?vue&type=script&lang=js&"
export * from "./CategoriesAltum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports